import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Select, Switch, Tooltip } from "antd";
import React, { useContext } from "react";
import CloseIconJsx from "../../reviews/closeIcon";
import { UserContext } from "../../../amplify/authenticator-provider";

export function TranslationSettings({
  setVisibleTranslationSetting,
  targetLangForCustomer,
  setTargetLangForCustomer,
  updateTranslationSetting,
  targetLangForEmployee,
  isAutoTranslate,
  isIncludeOriginalMessage,
  isTranslatePreviewShow,
  selectedLead,
  languages,
  setTargetLangForEmployee,
  setIsAutoTranslate,
  setIsIncludeOriginalMessage,
  setIsTranslatePreviewShow,
  page,
}) {
  const { user } = useContext(UserContext);

  const currentLocation = user?.locations?.find(
    location => +location?.location?.id === +sessionStorage.getItem("currentLocationId")
  );

  const isTranslationOff = currentLocation?.location?.settings?.DISABLE_TRANSLATION;

  return (
    <div className="w-full max-w-[540px]">
      <div className="flex justify-between items-center gap-4 mb-2">
        <span
          style={{
            color: "#334155",
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          Translator Settings
        </span>
        <Button type="text" onClick={() => setVisibleTranslationSetting(false)}>
          <CloseIconJsx />
        </Button>
      </div>
      <div className="flex justify-between items-center gap-4 mb-2">
        <span>Customer Speaks:</span>
        <Select
          disabled={isTranslationOff}
          value={targetLangForCustomer}
          style={{ minWidth: 190 }}
          onChange={value => {
            page = 1;
            if (value) {
              setTargetLangForCustomer(value);
            } else {
              setTargetLangForCustomer("");
            }
            updateTranslationSetting({
              variables: {
                customerLanguage: value,
                userLanguage: targetLangForEmployee,
                isAutomaticTranslation: isAutoTranslate,
                isIncludeOriginalMessage: isIncludeOriginalMessage,
                isTranslationPreview: isTranslatePreviewShow,
                leadId: selectedLead?.id,
              },
            });
          }}
          options={languages?.map(item => ({
            value: item?.languageCode,
            label: item?.languageName,
          }))}
        />
      </div>
      <div className="flex justify-between items-center gap-4 mb-2">
        <span>You Speak:</span>
        <Select
          disabled={isTranslationOff}
          value={targetLangForEmployee}
          style={{ minWidth: 190 }}
          onChange={value => {
            page = 1;
            if (value) {
              setTargetLangForEmployee(value);
            } else {
              setTargetLangForEmployee("");
            }
            updateTranslationSetting({
              variables: {
                customerLanguage: targetLangForCustomer,
                userLanguage: value,
                isAutomaticTranslation: isAutoTranslate,
                isIncludeOriginalMessage: isIncludeOriginalMessage,
                isTranslationPreview: isTranslatePreviewShow,
                leadId: selectedLead?.id,
              },
            });
          }}
          options={languages?.map(item => ({
            value: item?.languageCode,
            label: item?.languageName,
          }))}
        />
      </div>
      <div className="flex justify-between items-center gap-4 mb-2">
        <span style={{ marginRight: 8 }}>
          Automatic Translation:
          <Tooltip title="The received message will be automatically translated without manually clicking translate.">
            <InfoCircleOutlined className="scale-75" />
          </Tooltip>
        </span>
        <Switch
          checked={isAutoTranslate}
          onChange={value => {
            setIsAutoTranslate(value);
            updateTranslationSetting({
              variables: {
                customerLanguage: targetLangForCustomer,
                userLanguage: targetLangForEmployee,
                isAutomaticTranslation: value,
                isIncludeOriginalMessage: isIncludeOriginalMessage,
                isTranslationPreview: isTranslatePreviewShow,
                leadId: selectedLead?.id,
              },
            });
          }}
        />
      </div>
      <div className="flex justify-between items-center gap-4 mb-2">
        <span style={{ marginRight: 8 }}>
          Include original message:
          <Tooltip title="This option defines if the original from the customer and message you typed will be included or not to the translation.">
            <InfoCircleOutlined className="scale-75" />
          </Tooltip>
        </span>
        <Switch
          checked={isIncludeOriginalMessage}
          onChange={value => {
            setIsIncludeOriginalMessage(value);
            updateTranslationSetting({
              variables: {
                customerLanguage: targetLangForCustomer,
                userLanguage: targetLangForEmployee,
                isAutomaticTranslation: isAutoTranslate,
                isIncludeOriginalMessage: value,
                isTranslationPreview: isTranslatePreviewShow,
                leadId: selectedLead?.id,
              },
            });
          }}
        />
      </div>
      <div className="flex justify-between items-center gap-4 mb-2">
        <span style={{ marginRight: 8 }}>
          Translation Preview:
          <Tooltip title="This option is for displaying a translate icon to translate the content of the message box.">
            <InfoCircleOutlined className="scale-75" />
          </Tooltip>
        </span>
        <Switch
          checked={isTranslatePreviewShow}
          onChange={value => {
            setIsTranslatePreviewShow(value);
            updateTranslationSetting({
              variables: {
                customerLanguage: targetLangForCustomer,
                userLanguage: targetLangForEmployee,
                isAutomaticTranslation: isAutoTranslate,
                isIncludeOriginalMessage: isIncludeOriginalMessage,
                isTranslationPreview: value,
                leadId: selectedLead?.id,
              },
            });
          }}
        />
      </div>
    </div>
  );
}
